import { createSelector } from '@reduxjs/toolkit';

import { currentOpenChatSelector } from '../currentOpenChatSelector';

export const hintQuestionsSelector = createSelector(
  currentOpenChatSelector,
  openChat => openChat?.hintQuestions.hints || [],
);
